import type { ParsedListingFilters } from '../types';

// Query param key used by backend for a single fandom value in listingGetUrl/sourceGetUrl
const FANDOM_SINGULAR_KEY = 'fandom';
const FANDOM_PLURAL_KEY = 'fandoms';

const parseCommaSeparatedParam = (searchParams: URLSearchParams, key: string): string[] => {
  const raw = searchParams.get(key);
  return raw ? raw.split(',').filter(Boolean) : [];
};

/**
 * Parses filter values out of a backend-provided listing query string
 * (e.g. "/fanfics?fandom=10529&ratings=0") into the shape used by FilterState.
 * Handles the singular `fandom` key sent by backend vs. plural `fandoms` used on the client.
 */
export const parseListingGetUrl = (listingGetUrl: string): ParsedListingFilters => {
  const queryStr = listingGetUrl.split('?')[1] || '';
  const searchParams = new URLSearchParams(queryStr);

  const fandomsFromSingular = parseCommaSeparatedParam(searchParams, FANDOM_SINGULAR_KEY);
  const fandomsFromPlural = parseCommaSeparatedParam(searchParams, FANDOM_PLURAL_KEY);

  const tagsFromPlural = parseCommaSeparatedParam(searchParams, 'tags');
  const tagsFromSingular = parseCommaSeparatedParam(searchParams, 'tag');

  const pairingFromCanonical = parseCommaSeparatedParam(searchParams, 'pairingCharacters');
  const pairingFromLegacy = parseCommaSeparatedParam(searchParams, 'pairing');

  return {
    fandoms: fandomsFromSingular.length > 0 ? fandomsFromSingular : fandomsFromPlural,
    tags: tagsFromPlural.length > 0 ? tagsFromPlural : tagsFromSingular,
    universes: parseCommaSeparatedParam(searchParams, 'universes'),
    statuses: parseCommaSeparatedParam(searchParams, 'statuses'),
    ratings: parseCommaSeparatedParam(searchParams, 'ratings'),
    characters: parseCommaSeparatedParam(searchParams, 'characters'),
    pairingCharacters: pairingFromCanonical.length > 0 ? pairingFromCanonical : pairingFromLegacy,
  };
};
